var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-button',{staticClass:"subscriptionform-elbtn",attrs:{"type":"primary","plain":""},on:{"click":_vm.onClickThisButton}},[_vm._v(_vm._s(_vm.ButtonTextName))])}
var staticRenderFns = []

export { render, staticRenderFns }